"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCIAL_MEDIA_ICON = exports.FOLLOW_US = void 0;
const FOLLOW_US = exports.FOLLOW_US = 'follow-us';
const SOCIAL_MEDIA_ICON = exports.SOCIAL_MEDIA_ICON = 'social-media-icon';
